import { render, staticRenderFns } from "./systems-tab.vue?vue&type=template&id=713c1431"
import script from "./systems-tab.ts?vue&type=script&lang=js&external"
export * from "./systems-tab.ts?vue&type=script&lang=js&external"
import style0 from "./systems-tab.less?vue&type=style&index=0&lang=less&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('713c1431')) {
      api.createRecord('713c1431', component.options)
    } else {
      api.reload('713c1431', component.options)
    }
    module.hot.accept("./systems-tab.vue?vue&type=template&id=713c1431", function () {
      api.rerender('713c1431', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/event/event-info/tabs/systems-tab/systems-tab.vue"
export default component.exports